/* eslint-disable */
'use client'

import React from 'react'
import { X, Minus } from 'lucide-react'
import apiConfig from '../apiConfig'
import { themeColors } from '../theme'

interface NavProps {
  fontSize: number
  setFontSize: (size: number) => void
  onClose: () => void
  onMinimize: () => void
}

export const Nav: React.FC<NavProps> = ({ onClose, onMinimize }) => {
  // Move to prod by removing perf from hrccb.perf.target.com
  const baseUrl =
    apiConfig.chatApi?.gatewayBaseUrl || 'https://hrccb.target.com'

  return (
    <div
      style={{
        padding: '0.75rem 1rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 'auto',
        borderBottom: '1px solid #ccc',
        zIndex: 50,
        backgroundColor: themeColors.navBar,
        border: `1px solid ${themeColors.border}`,
        color: themeColors.standardText,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
      }}
    >
      {/* Logo and text wrapper */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* Target Logo */}
        <img
          src={`${baseUrl}/Bullseye_Red_CMYK.svg`}
          alt="Target Logo"
          style={{ width: '32px', height: '32px' }}
        />

        {/* Text Container */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <b
            style={{
              fontFamily:
                '"Helvetica for Target", HelveticaForTarget, Targetica, "HelveticaNeue for Target", "Helvetica Neue", Helvetica, Arial, sans-serif',
              fontWeight: 'bold',
              fontSize: '17px',
              color: themeColors.navBarText,
            }}
          >
            Careers AI Assistant
          </b>
          <span
            style={{
              fontSize: '14px',
              color: themeColors.navBarTextLetsChat,
              marginTop: '2px',
            }}
          >
            Let's chat!
          </span>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={onClose}
          aria-label="Close chat"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = themeColors.XCancelHover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent'
          }}
        >
          <X size={16} color={themeColors.XCancel} />
        </button>
      </div>
    </div>
  )
}
